import { useRouter } from 'next/router'
import { useEffect, useMemo } from 'react'

import { useGetClientConfig } from '@/gql/auth'
import { QUERY_PARAMS, SCOPE_CLIENT_ID_MAP } from '@/constants'
import { sendError } from '@/utils/rollbar'
import { getQueryParamValueAsString } from '@/utils/url'

import useScope from './useScope'

const DEFAULT_CONFIG = {
  recaptchaEnabled: true,
}

export default function useClientConfig() {
  const router = useRouter()
  const { scope } = useScope()

  const clientId = getQueryParamValueAsString(QUERY_PARAMS.clientId, router.query) || SCOPE_CLIENT_ID_MAP[scope]

  const { data, loading, error } = useGetClientConfig({ skip: !clientId, variables: { clientId } })

  useEffect(() => {
    if (error) {
      sendError(error, `Error fetching client config: ${clientId}`)
    }
  }, [error])

  const value = useMemo(
    () => ({
      ready: !loading,
      clientId,
      ...DEFAULT_CONFIG,
      ...data?.getClientConfig,
    }),
    [loading, data, clientId],
  )

  return value
}
